<template>
  <Plugin
    v-if="privacyEnable"
    from="m/platform/plugin/common"
    name="privacy-dialog"
    :props="{ scene: 'HOME_PRIVACY' }"
    :emit="{
      onReady: bindShowPrivacyDialog,
      onCompleted: handleCompleted,
      onError: handleError,
    }"
  />
  <slot v-if="completed" />
</template>

<script setup>
import { usePluginReadyEmit } from "app-core";
import { onMounted, ref } from "vue";
const [showPrivacyDialog, bindShowPrivacyDialog] = usePluginReadyEmit();
const privacyEnable =
  window.$ZConfig.getVal("HOME_PRIVACY_AUTHORIZATION") === "1";
const completed = ref(!privacyEnable);

const handleCompleted = () => {
  completed.value = true;
};

const handleError = () => {
  completed.value = true;
};

onMounted(() => {
  showPrivacyDialog();
});
</script>
